import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class Audit extends DynamicFieldsSerializer {
  namespace = 'people';
  rootKeys = ['people', 'person'];
}
